import React from 'react'
import { useReactiveVar } from '@apollo/client'
import { Printable } from '../../common/Printable'
import { calculatorVar } from '../../../apollo/reactive-vars'
import type {
  BoreholeFieldContainerInput,
  EnergyBusFragment,
} from '../../../generated/graphql'
import { useEnergyBus } from '../../../energy-bus/use-energy-bus'
import { EnergyBusBoreholeField } from './EnergyBusBoreholeField'

type Props = {
  energyBus: EnergyBusFragment
}

export function EnergyBusBoreholeFieldTab({
  energyBus,
}: Props): React.ReactElement {
  const calculator = useReactiveVar(calculatorVar)
  const { updateEnergyBusBoreholeField } = useEnergyBus()

  const energyBusCalculator = calculator?.findEnergyBus()

  const updateContainer = async (input: BoreholeFieldContainerInput) => {
    await updateEnergyBusBoreholeField(energyBus.id, input)
  }

  if (!energyBusCalculator) {
    return <></>
  }

  return (
    <Printable>
      <EnergyBusBoreholeField
        container={energyBus}
        updateContainer={updateContainer}
        energyBusCalculator={energyBusCalculator}
      />
    </Printable>
  )
}
